import cn from '@/utils/cn';

// The print tools' status colours on the sysadmin SPA tokens, so the tool reads the same inside
// the SPA (dark or light) and on the legacy pages, which pin the light set. Tints are a color-mix
// of the tone's text token, the same recipe as SPAPill.
export type Tone = 'accent' | 'error' | 'neutral' | 'success' | 'warning';

const tint = (token: string) => `tw-bg-[color:color-mix(in_srgb,var(${token})_12%,transparent)]`;

export const toneText: Record<Tone, string> = {
  accent: 'tw-text-spa-accent-text',
  error: 'tw-text-spa-error',
  neutral: 'tw-text-spa-secondary',
  success: 'tw-text-spa-success',
  warning: 'tw-text-spa-warning',
};

export const toneTint: Record<Tone, string> = {
  accent: 'tw-bg-spa-accent-bg',
  error: tint('--spa-text-error'),
  neutral: 'tw-bg-spa-bg-tertiary',
  success: tint('--spa-text-success'),
  warning: tint('--spa-text-warning'),
};

export const toneBorder: Record<Tone, string> = {
  accent: 'tw-border-spa-accent',
  error: 'tw-border-spa-error',
  neutral: 'tw-border-spa-border',
  success: 'tw-border-spa-success',
  warning: 'tw-border-spa-warning',
};

// A bordered, tinted box for a banner or callout.
export const calloutClass = (tone: Tone) => cn(
  'tw-rounded tw-border tw-border-solid tw-p-3',
  toneTint[tone],
  toneBorder[tone],
);

// A hand-built table framed like SPADataTable (which owns these strings for its own header).
export const tableHeaderRowClass = cn(
  'tw-bg-spa-bg-tertiary',
  'tw-border-b-2 tw-border-solid tw-border-x-0 tw-border-t-0 tw-border-spa-border',
);
export const tableHeaderCellClass = cn(
  'tw-text-spa-heading tw-text-xs tw-uppercase tw-tracking-wider tw-font-semibold tw-px-4 tw-py-3',
);
